import { createFileRoute } from "@tanstack/react-router"
import { AuthRoute } from "@/app"

export const Route = createFileRoute("/(public)/auth")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AuthRoute />
}
